import { LTG_UI_StatementMediator } from "../Mediator/LTG_UI_StatementMediator";
export class LTG_Com_StatementData {
    constructor() {
        /**
         * 0 选择按钮 1开关选择
         */
        this.state = 0;
    }
    Send() {
        if (window["__GM"])
            return 0;
        LTG_UI_StatementMediator.instance.Show(this);
        return 0;
    }
}
